export const PRIMARY_COLOR = '#3B9CFF';

export const BLACK_COLOR = '#1f1f24';
export const WHITE_COLOR = '#fefefe';
